/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import Container from '@/components/Container';
import { getAuthors } from '@/services/knowledge-hub/utils';
import { ResourceEntity } from '@/graphql/generated/graphql';
import { useKnowledgeHubStore } from './store/useKnowledgeHubStore';
import { Link, useNavigate } from 'react-router-dom';
import DefaultContentTemplateTags from '@/components/DefaultContentTemplate/Tags';
import AnimatedFadeInComponent from '@/components/AnimatedFadeInComponent';
import { useRef } from 'react';
import { useResponsiveImage } from '@/utils/useResponsiveImage';

export default function Highlight({ highlightsForTopic = [] }: { highlightsForTopic: ResourceEntity[] }) {
  const { page } = useKnowledgeHubStore();
  const imgRef = useRef<HTMLImageElement>(null);
  const highlight = highlightsForTopic[0];
  const { src } = useResponsiveImage(highlight?.attributes?.cover);

  const navigate = useNavigate();

  if (!highlightsForTopic?.length) {
    return null;
  }

  return (
    <AnimatedFadeInComponent id="highlight">
      <Container>
        <div className=" col-span-12 flex flex-col items-start lg:col-start-11 lg:col-end-3">
          <h2 className="font-larken text-sh-md">{page.page?.highlightOfTheWeekTitle}</h2>
          <div key={highlight.id} className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-[415px_1fr]">
            <div className="flex aspect-square items-center justify-center overflow-hidden rounded-2xl">
              <img
                ref={imgRef}
                onClick={() => {
                  navigate(`/knowledge-hub/slug/${highlight.attributes?.slug}`);
                }}
                className="h-full w-full cursor-pointer rounded-2xl object-cover duration-500 ease-linear hover:scale-110"
                src={src}
                alt={highlight.attributes?.title?.toString() || ''}
              />
            </div>
            <div>
              {highlight?.attributes?.resourceType?.data?.attributes?.type?.toString() ? (
                <DefaultContentTemplateTags
                  duration={highlight?.attributes?.duration?.toString() || ''}
                  tags={[highlight?.attributes?.resourceType?.data?.attributes?.type?.toString() || '']}
                  className="!mb-sh-15 !mt-0"
                />
              ) : null}
              <Link
                onMouseEnter={() => {
                  if (imgRef.current) {
                    imgRef.current.classList.add('scale-110');
                  }
                }}
                onMouseLeave={() => {
                  if (imgRef.current) {
                    imgRef.current.classList.remove('scale-110');
                  }
                }}
                className="md:sh-36-48 font-larken text-sh-36-48"
                to={`/knowledge-hub/slug/${highlight.attributes?.slug}`}>
                {highlight?.attributes?.title}
              </Link>
              <p className="mt-2 text-sh-xxs md:text-sh-sm">{highlight?.attributes?.briefDescription}</p>
              <p className="text-sh-xxxs text-sh-grey-500">by {getAuthors(highlight)}</p>
            </div>
          </div>
        </div>
      </Container>
    </AnimatedFadeInComponent>
  );
}
